import _core from "./core";
import * as _fizzyUiUtils2 from "fizzy-ui-utils";

var _fizzyUiUtils = "default" in _fizzyUiUtils2 ? _fizzyUiUtils2.default : _fizzyUiUtils2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// lazyload
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_core, _fizzyUiUtils);
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != "undefined" ? window : exports, function factory(Flickity, utils) {
  const lazyAttr = "data-flickity-lazyload";
  const lazySrcAttr = `${lazyAttr}-src`;
  const lazySrcsetAttr = `${lazyAttr}-srcset`;
  const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;

  Flickity.create.lazyLoad = function () {
    this.on("select", (this || _global).lazyLoad);
    (this || _global).handleLazyLoadComplete = (this || _global).onLazyLoadComplete.bind(this || _global);
  };

  let proto = Flickity.prototype;

  proto.lazyLoad = function () {
    let {
      lazyLoad
    } = (this || _global).options;
    if (!lazyLoad) return; // get adjacent cells, use lazyLoad option for adjacent count

    let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0; // lazy load images

    this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach(img => new LazyLoader(img, (this || _global).handleLazyLoadComplete));
  };

  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.matches("img")) {
      let cellAttr = cellElem.getAttribute(lazyAttr);
      let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
      let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);

      if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
        return cellElem;
      }
    } // select lazy images in cell


    return [...cellElem.querySelectorAll(imgSelector)];
  }

  proto.onLazyLoadComplete = function (img, event) {
    let cell = this.getParentCell(img);
    let cellElem = cell && cell.element;
    this.cellSizeChange(cellElem);
    this.dispatchEvent("lazyLoad", event, cellElem);
  }; // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   * @param {Image} img - Image element
   * @param {Function} onComplete - callback function
   */


  function LazyLoader(img, onComplete) {
    (this || _global).img = img;
    (this || _global).onComplete = onComplete;
    this.load();
  }

  LazyLoader.prototype.handleEvent = utils.handleEvent;

  LazyLoader.prototype.load = function () {
    (this || _global).img.addEventListener("load", this || _global);

    (this || _global).img.addEventListener("error", this || _global); // get src & srcset


    let src = (this || _global).img.getAttribute(lazyAttr) || (this || _global).img.getAttribute(lazySrcAttr);

    let srcset = (this || _global).img.getAttribute(lazySrcsetAttr); // set src & serset


    (this || _global).img.src = src;
    if (srcset) (this || _global).img.setAttribute("srcset", srcset); // remove attr

    (this || _global).img.removeAttribute(lazyAttr);

    (this || _global).img.removeAttribute(lazySrcAttr);

    (this || _global).img.removeAttribute(lazySrcsetAttr);
  };

  LazyLoader.prototype.onload = function (event) {
    this.complete(event, "flickity-lazyloaded");
  };

  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, "flickity-lazyerror");
  };

  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    (this || _global).img.removeEventListener("load", this || _global);

    (this || _global).img.removeEventListener("error", this || _global);

    let mediaElem = (this || _global).img.parentNode.matches("picture") ? (this || _global).img.parentNode : (this || _global).img;
    mediaElem.classList.add(className);
    this.onComplete((this || _global).img, event);
  }; // -----  ----- //


  Flickity.LazyLoader = LazyLoader;
  return Flickity;
});

export default exports;